const dates = {
    addDays: function (date, days) {
        date.setDate(date.getDate() + days);
        return date;
    },

    getTradePeriodName: function (startDate, endDate) {
        if (Date.parse(startDate) >= Date.parse(endDate)) {
            throw new Error("'startDate' must be earlier than the 'endDate'. Please correct the dates.");
        }

        startDate = new Date(startDate);
        endDate = new Date(endDate)

        var yearSuffix = startDate.getFullYear().ToString().Substring(2);
        var numOfDays = this.getDateDiffInDays(startDate, endDate);
        var tradeablePeriod = null;

        // potential M, Q, or CAL periods
        if (startDate.getFullYear() === endDate.getFullYear()) {
            // month
            if (numOfDays <= 31 && numOfDays >= 28) {
                startDate = this.addDays(startDate, 1);
                tradeablePeriod = startDate.toLocaleString('default', { month: 'short' }) + "-" + yearSuffix;
            }

            //quarter
            if (numOfDays <= 92 && numOfDays >= 90) {
                startDate = this.addDays(startDate, 1);

                if (this.getQuarter(startDate) === 1) {
                    tradeablePeriod = "Q1-" + yearSuffix;
                } else if (this.getQuarter(startDate) === 2) {
                    tradeablePeriod = "Q2-" + yearSuffix;
                } else if (this.getQuarter(startDate) === 3) {
                    tradeablePeriod = "Q3-" + yearSuffix;
                } else {
                    tradeablePeriod = "Q4-" + yearSuffix;
                }
            }

            // summer season
            if (numOfDays >= 182 && numOfDays <= 183) {
                startDate = this.addDays(startDate, 1);

                if (startDate.toLocaleString('default', { month: 'short' }) === "Apr") {
                    tradeablePeriod = "Sum-" + yearSuffix;
                }
            }

            // calendar
            if (numOfDays >= 364 && numOfDays <= 366) {
                tradeablePeriod = "Cal-" + yearSuffix;
            }
        } else if (startDate.getFullYear() + 1 === endDate.getFullYear()) {
            if (numOfDays >= 182 && numOfDays <= 183) {
                startDate = this.addDays(startDate, 1);

                if (startDate.toLocaleString('default', { month: 'short' }) === "Oct") {
                    tradeablePeriod = "Win-" + yearSuffix;
                }
            }
        }

        return tradeablePeriod;
    },

    getDateDiffInDays: function (startDate, endDate) {
        var result = Math.round(Math.abs((startDate - endDate) / (24 * 60 * 60 * 1000))) + 1;
        return result;
    },
    getBusinessDatesCount: function (startDate, endDate) {
        if (startDate == undefined || endDate == undefined)
            return 0;

        let count = 0;
        //set dates to have 0 hours,minutes... as otherwise for october it does the matching and due to daylight saving change it doesnt match the last day and we dont calculate it.
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        const curDate = new Date(startDate.getTime());
        while (curDate <= endDate) {
            const dayOfWeek = curDate.getDay();
            if (dayOfWeek !== 0 && dayOfWeek !== 6) count++;
            curDate.setDate(curDate.getDate() + 1);
        }
        return count;
    },
    getQuarter: function (date) {
        date = new Date(date);

        return Math.floor((date.getMonth() + 3) / 3);
    }
}

export default dates;